import { sendPoint } from '@/apis/btBoxActivity'
import { burnPoint } from '@/apis/heziShare'
import { queue } from "@/libs/queue.request";
import { signInEventTrack, getUserInfo, toLogin } from "@/bridge/AppJsBridge"
import { getCookie } from "@/libs/utils";
import { inithandler } from "@/bridge/jsBridge";

export default {
  data() {
    return {
      reqQueue: queue(),
      cookie: null,
    }
  },
  created () {
    // 避免重复调用 bridge.init()
    if (!this.skipInit) {
      // 页面初始化
      inithandler();
    }
    this.reqQueue.create()

    const pageCookie = getCookie();
    if (pageCookie) {
      for (const key in pageCookie) {
        if (
          Object.hasOwnProperty.call(pageCookie, key) &&
          pageCookie[key] === "null"
        ) {
          delete pageCookie[key];
        }
      }
      this.cookie = pageCookie;
    }
    try {
      signInEventTrack((data) => {
        this.cookie = JSON.parse(data);
      })
    } catch (error) {
      // 错误处理
    }
  },
  watch: {
    cookie(value, oldValue){
      if (!oldValue && value && !getCookie()) {
        this.reqQueue.run(value);
      }
    },
  },
  methods: {
    // 数据上报
    eventTrack (data) {
      const api = this.isWx ? burnPoint : sendPoint
      if (!this.cookie) {
        console.log("数据上报异常", data.event, "转为补充数据上报")
        this.reqQueue.add(api, data)
        return
      }
      console.log("正常数据上报", data)
      api({
        ...this.cookie,
        ...data,
      }).catch((err) => console.log(err));
    },
    getAppToken (needCallLogin) {
      const token = getCookie("token")
      if (token) {
        localStorage.setItem("token", token);
        this.getActivityInfo()
      } else {
        // 多次调用会覆盖之前的回调
        getUserInfo((userInfo) => {
          let Info = JSON.parse(userInfo);
          if (Info.token) {
            localStorage.setItem("token", Info.token);
            this.getActivityInfo()
          } else {
            if (needCallLogin) {
              toLogin("/loginKey/LoginByKeyPhoneActivity");
            }
          }
        });
      }
    },
    // 具体引用页去覆盖
    getActivityInfo () {}
  },
}